import { DatePipe } from '@angular/common';
import { Component, inject, input, LOCALE_ID } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { IBms } from '../../../../models/bms';
import { Functions } from '../../../../services/shared/functions';
import { IconsStyles } from '../../../../services/shared/icons-styles';

@Component({
  selector: 'app-bms-table',
  imports: [PanelModule, TableModule, DatePipe, TooltipModule],
  templateUrl: './bms-table.html',
  styleUrl: './bms-table.css',
})
export class BmsTable {
  BMSList = input.required<IBms[]>();
  isLoading = input.required<boolean>();
  readonly locale = inject(LOCALE_ID);
  readonly iconsStyles = inject(IconsStyles);
  readonly customFunctions = inject(Functions);
  readonly shouldBeCollapsed = this.customFunctions.shouldBeCollapsed();
}
